package wat.ui

import kotlinx.browser.document
import kotlinx.browser.window
import kotlinx.coroutines.GlobalScope
import kotlinx.coroutines.launch
import org.w3c.dom.HTMLDivElement
import wat.Supa

object App {
    fun init() {
        val root = document.getElementById("root") as HTMLDivElement
        root.innerHTML = ""

        // Init theme before anything renders
        ThemeManager.init()

        // Init debug log panel
        DebugLog.init()
        DebugLog.log("=== TRACTOR Kotlin/JS starting ===")
        DebugLog.log("URL: ${window.location.href}")
        DebugLog.log("UserAgent: ${window.navigator.userAgent}")

        // Check if Supabase CDN loaded
        val supabaseGlobal = js("typeof window.supabase")
        DebugLog.log("window.supabase type: $supabaseGlobal", "NET")
        if (supabaseGlobal == "undefined") {
            DebugLog.error("Supabase CDN NOT loaded! window.supabase is undefined")
            DebugLog.error("Check: <script src=\"https://cdn.jsdelivr.net/npm/@supabase/supabase-js@2\"></script>")
            showErrorPage(root, "Supabase CDN not loaded - window.supabase is undefined")
            return
        }
        DebugLog.ok("Supabase CDN loaded")

        // Try to create client
        try {
            DebugLog.log("Creating Supabase client...", "NET")
            val client = Supa.client
            DebugLog.ok("Supabase client created")
            val authType = js("typeof client.auth")
            DebugLog.log("client.auth type: $authType", "NET")
        } catch (e: Exception) {
            DebugLog.error("Failed to create Supabase client: ${e.message}")
            DebugLog.error("Stack: ${e.stackTraceToString()}")
            showErrorPage(root, "Supabase client creation failed: ${e.message}")
            return
        }

        // Check auth state
        DebugLog.auth("Checking session...")
        GlobalScope.launch {
            try {
                val res = Supa.getSession()
                DebugLog.auth("getSession() returned")
                DebugLog.logJson("Session response", res)

                val error = res.error
                if (error != null && error != undefined) {
                    DebugLog.error("Session error: ${error.message}")
                }

                val session = res.data?.session
                DebugLog.auth("session exists: ${session != null && session != undefined}")

                if (session != null && session != undefined) {
                    val userId = session.user?.id?.toString() ?: "?"
                    DebugLog.auth("User ID: $userId")
                    DebugLog.auth("Email: ${session.user?.email}")
                    root.appendChild(MainApp.render(session))
                } else {
                    DebugLog.auth("No active session - showing auth screen")
                    showAuth(root)
                }
            } catch (e: Exception) {
                DebugLog.error("Session check EXCEPTION: ${e.message}")
                DebugLog.error("Stack: ${e.stackTraceToString()}")
                showAuth(root)
            }
        }

        // Listen for auth changes
        try {
            Supa.onAuthStateChange { event, session ->
                DebugLog.auth("Auth state changed: event=$event")
                if (event == "SIGNED_OUT") {
                    DebugLog.auth("Signed out - reinitializing")
                    init()
                }
            }
        } catch (e: Exception) {
            DebugLog.error("onAuthStateChange failed: ${e.message}")
        }
    }

    private fun showAuth(root: HTMLDivElement) {
        AuthScreen.onAuth = { session ->
            DebugLog.auth("Auth callback - user authenticated, clearing saved page")
            try { window.sessionStorage.removeItem("wat_page") } catch (_: Exception) {}
            root.innerHTML = ""
            root.appendChild(MainApp.render(session))
        }
        root.appendChild(AuthScreen.render())
    }

    private fun showErrorPage(root: HTMLDivElement, msg: String) {
        root.appendChild(div {
            style.cssText = "min-height:100vh;display:flex;align-items:center;justify-content:center;flex-direction:column;padding:20px"
            appendChild(span("TRACTOR") {
                style.cssText = "font-size:48px;font-weight:900;letter-spacing:-2px;background:linear-gradient(135deg,#2dd4bf,#818cf8,#c084fc);-webkit-background-clip:text;-webkit-text-fill-color:transparent;margin-bottom:20px"
            })
            appendChild(div {
                style.cssText = "color:#fb7185;font-size:14px;font-weight:700;margin-bottom:10px"
                textContent = "Error"
            })
            appendChild(div {
                style.cssText = "color:${Styles.TEXT_SEC};font-size:12px;max-width:400px;text-align:center;word-break:break-all"
                textContent = msg
            })
        })
    }
}
